import { createStore, createStyleSet } from 'botframework-webchat';
import React, { memo, useCallback, useMemo, useState } from 'react';
import { Middleware } from 'redux';
import { appConfig } from '../../../utils/app.config';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import warwickbotlogo from '../../../assets/warwickBotlogo_final.png';
import './FullScreenWebChat.css';
import WebChat from './WebChat';

function FullScreenWebChat({ bot = "B0001" }) {
    const [token, setToken] = useState<string>('');
    const [sendMessage, setSendMessage] = useState(false); // Track voice state
    const [message, setMessage] = useState('');
    const [isListening, setIsListening] = useState(false); // Track if listening to speech
    const [newMessage, setNewMessage] = useState(false);
    // Middleware for Redux store
    const middleware: Middleware = ({ dispatch }) => (next) => (action: any) => {
        // if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
        //     dispatch({
        //         type: 'WEB_CHAT/SEND_EVENT',
        //         payload: {
        //             name: 'webchat/join',
        //             value: {
        //                 language: window.navigator.language
        //             }
        //         }
        //     });
        // }
        // else if (action.type === 'DIRECT_LINE/INCOMING_ACTIVITY') {
        //     if (action.payload.activity.from.role === 'bot') {
        //         setNewMessage(true);
        //     }
        // }

        return next(action);
    };

    const store = useMemo(() => createStore({}, middleware), []);

    const styleSet = useMemo(() => createStyleSet({
        backgroundColor: 'transparent'
    }), []);

    const styleOptions = useMemo(() => (
        {

            backgroundColor: 'Transparent',
            botAvatarImage: './static/img/logos/warwickBotlogo_final.png',
            botAvatarBackgroundColor: 'rgba(0, 0,255, .1)',
            botAvatarInitials: 'B',
            bubbleNubSize: 10,
            bubbleBorderRadius: 10,
            bubbleNubOffset: 6,
            bubbleBackground: 'rgba(0, 0, 255, .1)',
            bubbleFromUserBackground: 'rgba(0, 0, 255, 0.28)',
            userAvatarImage: './static/img/logos/User_Profile_Opt1_final.png',
            userAvatarInitials: 'U',
            userAvatarBackgroundColor: '#F77',
            bubbleFromUserBorderRadius: 10,
            bubbleFromUserNubOffset: 6,
            bubbleFromUserNubSize: 6,
            avatarSize: 40,
            emojiSet: {
                ':sheep:': '🐑',
                '<3': '❤️'
            },
            hideUploadButton: true, // Enable upload button
            uploadButtonColor: '#0078D4',
            sendBoxBackground: 'white',
            sendBoxTextColor: 'black'
        }
    ), []);

    const handleFetchToken = useCallback(async () => {
        const authToken = sessionStorage.getItem('cva.jwt.access.token');
        const requestBody = {
            "user": { "id": "test@rr.com", "name": "test" },
            "trustedOrigins": ["https://cva-dev.warwick.ac.uk"]
        };

        if (!token) {
            const res = await fetch(
                `${appConfig.baseUrl}/api/v2.0/litebot/tokens/generate?botId=${bot}&domainType=directline`,
                {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${authToken}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(requestBody)
                }
            );
            const { token } = await res.json();
            setToken(token);
        }
    }, [setToken, token]);

    // Voice recognition
    const handleVoiceButtonClick = useCallback(() => {
        if (isListening) {
            stopListening();
        } else {
            startListening();
        }
    }, [isListening]);

    const startListening = () => {
        setIsListening(true);
        // SpeechRecognition setup
        const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
        const recognition = new SpeechRecognition();
        recognition.continuous = false;
        recognition.interimResults = false;
        recognition.lang = 'en-US';

        recognition.onresult = (event: { results: { [x: string]: { transcript: any; }[]; }; resultIndex: string | number; }) => {
            const transcript = event.results[event.resultIndex][0].transcript;
            console.log("Recognized Speech: ", transcript);
            sendToBot(transcript); // Send speech as text to bot
        };

        recognition.onend = () => {
            setIsListening(false); // Reset listening state
        };

        recognition.start();
    };

    const stopListening = () => {
        setIsListening(false);
        const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
        if (SpeechRecognition) {
            const recognition = new SpeechRecognition();
            recognition.stop();
        }
    };

    const sendToBot = (message: any) => {
        setMessage(message);
        setSendMessage(true);
    };

    return (
        <div className="full-screen-web-chat">
            <div className="chat-box full-screen">
                <header>
                    <div className="chat-brand-logo">
                        <img src={warwickbotlogo} alt="Company Logo" />
                        <div className="chat-brand-txt"><span>Itika</span></div>
                    </div>
                    {/* Voice Button */}
                    {/* <div className="filler" />
                    <div>
                        <button className="voice" onClick={handleVoiceButtonClick} type="button">
                            <i className={isListening ? 'bi-mic-fill text-success' : 'bi-mic'}></i>
                        </button>
                    </div> */}
                </header>

                <WebChat
                    className="react-web-chat"
                    onFetchToken={handleFetchToken}
                    store={store}
                    styleOptions={styleOptions}
                    styleSet={styleSet}
                    token={token}
                    sendMessage={sendMessage}
                    setSendMessage={(value) => { setSendMessage(value) }}
                    message={message}
                />
            </div>
        </div>
    );
}

export default memo(FullScreenWebChat);
